import { Injectable } from "@angular/core"
import { AngularFirestoreCollection } from "@angular/fire/firestore"
import { NeedApproval } from "@tr/models"
import { FirebaseCollectionBase } from "./firebase-resource-base"
import { FirebaseService } from "./firebase.service"

@Injectable({
  providedIn: "root",
})
export class ApprovalBugsService extends FirebaseCollectionBase<NeedApproval> {
  public getId = (item: NeedApproval) => item._id
  constructor(fb: FirebaseService) {
    super(fb)
  }

  public getCollection(): AngularFirestoreCollection<NeedApproval> {
    return this.firebaseService
      .collection("Managers")
      .doc("Needs Approval Bugs")
      .collection<NeedApproval>("Needs Approval")
  }
}
